import RoomsContent from './Content'
import * as React from 'react'
import { RefObject } from 'react'

import DropdownList from 'LuxKit/Dropdown/List/DropdownList'

interface Props {
  open: boolean
  onClose: () => void
  onApply: () => void
  roomInputRef: RefObject<HTMLButtonElement | null>
  rooms: Array<App.Occupants>
  onRoomCountChange: (roomCount: number) => void
  travellerCount: number
}

export default function RoomsDesktop({
  open,
  onClose,
  onApply,
  roomInputRef,
  rooms,
  onRoomCountChange,
  travellerCount,
}: Props) {
  return <DropdownList
    size="S"
    autoHeight
    anchorRef={roomInputRef}
    triggerRef={roomInputRef}
    open={open}
    onClose={onClose}
    primaryActionProps={{
      children: 'Apply',
      onClick: onApply,
    }}
    placement="bottom-start"
    portaled
  >
    <RoomsContent rooms={rooms} onRoomCountChange={onRoomCountChange} travellerCount={travellerCount} />
  </DropdownList>
}
